import { Menu } from '@mantine/core';
import { Icon, Switch } from '@repo/foundations';
import { useFullWidthToggle } from '../../../../hooks/useFullWidthToggle.ts';

interface ToggleFullWidthActionProps {
	entityId: string;
}

export function ToggleFullWidthAction({
	entityId,
}: ToggleFullWidthActionProps) {
	const { shouldSetFullWidth, toggle } = useFullWidthToggle(entityId);

	return (
		<Menu.Item
			onClick={toggle}
			closeMenuOnClick={false}
			icon={<Icon name="arrowAutofitWidth" />}
			rightSection={
				<Switch
					checked={shouldSetFullWidth}
					readOnly
					style={{ pointerEvents: 'none' }}
				/>
			}
		>
			Full width
		</Menu.Item>
	);
}
